import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-courses-filter.tsx
var LazyCoursesFilter = lazy(() => import("./courses-filter-Dex1pZ01.js").then((n) => n.n).then((module) => ({ default: module.CoursesFilter })));
function CoursesFilter({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-filter" }),
		children: /* @__PURE__ */ jsx(LazyCoursesFilter, { ...props })
	});
}
function CoursesFilterContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "courses-filter" }),
		children: /* @__PURE__ */ jsx(LazyCoursesFilter, { ...props })
	});
}
var useCoursesFilterContent = () => {
	return useMemo(() => ({ coursesFilter: { component: CoursesFilterContent } }), []);
};
//#endregion
export { CoursesFilter, useCoursesFilterContent };
